<div class="tab-content">
  <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
    <div class="row content-component">
      <div class="col-lg-12 col-md-12">
        <div class="main-card mb-3 card">
          <div class="card-body">

            <div id="smartwizard" class="forms-wizard nav nav-tabs step-anchor">
              <ul class="forms-wizard nav nav-tabs step-anchor">
                <li class="nav-item"
                  [ngClass]="{'done': process[0].finish && !process[0].active, 'active': process[0].active}">
                  <a>
                    <em (click)="active(0)">1</em><span>Cargar</span>
                  </a>
                </li>
                <li class="nav-item" [ngClass]="{'done': process[1].finish, 'active': process[1].active}">
                  <a>
                    <em (click)="active(1)">2</em><span>Validar</span>
                  </a>
                </li>
                <li class="nav-item" [ngClass]="{'done': process[2].finish, 'active': process[2].active}">
                  <a>
                    <em (click)="active(2)">3</em><span>Procesar</span>
                  </a>
                </li>
              </ul>

              <div class="form-wizard-content">
                <div id="step-1" [hidden]="!process[0].active ">
                  <div class="accordion-wrapper mb-3">
                    <div class="card">
                      <div class="card-body">
                        <div class="form-row">
                          <div class="contenedor">
                            <div class="row" style="text-align: center">
                              <div style="text-align:center">
                                <a>Instrucciones de uso del wizard</a>
                              </div>
                              <hr>
                              <div class="col-md-12">
                                <div class="col-md-12">
                                  <p class="downloadTemplate">
                                    <img src="../../../assets/images/cargaMasiva/download-archive.svg"
                                      alt="Descargar Template" (click)="downloadTemplate()">
                                    <span>Descargar Template</span>
                                  </p>
                                </div>
                                <div class="col-md-12" style="text-align: center; display: block;">
                                  <form [formGroup]="frmCarga" (ngSubmit)="SubmitInputFile(fileUploader)">
                                    <dx-file-uploader #fileUploader selectButtonText="Archivo(s)"
                                      labelText="O arrastre el archivo" accept=".xlsx, .xlsm"
                                      [allowedFileExtensions]="['.xlsx']" uploadMode="useForm" [allowCanceling]="true"
                                      (change)="onValueChanged($event, fileUploader)">
                                    </dx-file-uploader>
                                    <dx-button [useSubmitBehavior]="true" [disabled]="btnUpload"
                                      text="Subir Archivo(s)"></dx-button>
                                  </form>
                                </div>
                                <div class="col-md-12" style="text-align: center;">
                                  <span class="message">{{ message }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="step-2" [hidden]="!process[1].active">
                  <div id="accordion" *ngIf="arrayRowsFinalErrors.length > 0" class="accordion-wrapper mb-3">
                    <div class="card">
                      <div id="headingOne" class="card-header header-panel-error">
                        <button type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                          aria-controls="collapseOne" class="text-left m-0 p-0 btn btn-link col-md-6">
                          <span class="form-heading">Lista de errores
                          </span>
                        </button>
                      </div>
                      <div data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne" class="collapse show">
                        <div class="card-body">
                        </div>
                        <div class="col-md-12 col-lg-12 text-error">
                          {{ msgErrorServidor }}
                        </div>
                      </div>
                      <div data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne" class="collapse show">
                        <div class="card-body">
                          <dx-data-grid [dataSource]="arrayRowsFinalErrors" [columns]="columns"
                            [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true"
                            [rowAlternationEnabled]="true" [showBorders]="false" [showColumnLines]="false"
                            [showRowLines]="true" (onContentReady)="contentReady($event)"
                            (onExporting)="onExporting($event)" [columnAutoWidth]="true"
                            (onRowPrepared)="onRowPrepared($event)">
                            <dxo-paging [pageSize]="10"></dxo-paging>
                            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[15, 50, 100, 500]"
                              [visible]="true" [showPageSizeSelector]="true" [showInfo]="true"
                              [showNavigationButtons]="true">
                            </dxo-pager>
                          </dx-data-grid>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="accordion" *ngIf="msgErrorServidor" class="accordion-wrapper mb-3">
                    <div class="card">
                      <div id="headingOne" class="card-header header-panel-error">
                        <button type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                          aria-controls="collapseOne" class="text-left m-0 p-0 btn btn-link col-md-6">
                          <span class="form-heading">Lista de errores
                          </span>
                        </button>
                      </div>
                      <div data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne" class="collapse show">
                        <div class="card-body">
                        </div>
                        <div class="col-md-12 col-lg-12 text-error">
                          {{ msgErrorServidor }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="accordion" *ngIf="arrayRowsFinalErrors.length == 0 && arrayCatalogos"
                    class="accordion-wrapper mb-3">
                    <div class="card">
                      <div data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne" class="collapse show">
                        <div class="card-body">
                          <dx-data-grid [dataSource]="arrayCatalogos" [columns]="arrayProcesadoColumns"
                            [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true"
                            [rowAlternationEnabled]="true" [showBorders]="false" [showColumnLines]="false"
                            [showRowLines]="true" (onContentReady)="contentReady($event)"
                            (onExporting)="onExporting($event)" [columnAutoWidth]="true"
                            (onRowPrepared)="onRowPrepared($event)">
                            <dxo-paging [pageSize]="10"></dxo-paging>
                            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[15, 50, 100, 500]"
                              [visible]="true" [showPageSizeSelector]="true" [showInfo]="true"
                              [showNavigationButtons]="true">
                            </dxo-pager>
                          </dx-data-grid>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div id="step-3" [hidden]="!process[2].active">
                  <div id="accordion" *ngIf="arrayProcesadoErrors.length > 0 || msgErrorServidor != ''"
                    class="accordion-wrapper mb-3">
                    <div class="card">
                      <div id="headingOne" class="card-header header-panel-error">
                        <button type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                          aria-controls="collapseOne" class="text-left m-0 p-0 btn btn-link col-md-6">
                          <span class="form-heading">Lista de errores
                          </span>
                        </button>
                      </div>
                      <div data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne" class="collapse show">
                        <div class="card-body">
                        </div>
                        <div class="col-md-12 col-lg-12 text-error">
                          {{ msgErrorServidor }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="accordion" *ngIf="arrayProcesadoErrors.length == 0 && msgErrorServidor == ''">
                    <div class="swal2-icon swal2-success swal2-animate-success-icon">
                      <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
                      <span class="swal2-success-line-tip"></span>
                      <span class="swal2-success-line-long"></span>
                      <div class="swal2-success-ring"></div>
                      <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);">
                      </div>
                      <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);">
                      </div>
                    </div>
                    <div class="col-md-12" style="text-align:center">
                      <div class="btn-shadow btn-wide btn btn-success btn-lg">Proceso
                        finalizado
                        con éxito
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="clearfix">
                  <button type="button" (click)="next()" id="next-btn"
                    class="btn btn-primary btn-rounded mr-3 mb-3 text-white btn-action float-right"
                    [disabled]="!btnNextEnable || (indexActive == 1 && arrayRowsFinalErrors.length > 0)"
                    *ngIf="indexActive != 2">
                    <i class="fa fa-arrow-right"></i>
                    Siguiente
                  </button>

                  <button type="button" (click)="finalizar()" id="next-btn"
                    class="btn btn-primary btn-rounded mr-3 mb-3 text-white btn-action float-right"
                    *ngIf="indexActive == 2">
                    <i class="pe-7s-diskette btn-icon-wrapper"></i>
                    Finalizar
                  </button>

                  <button type="button" (click)="previous()" id="prev-btn" *ngIf="indexActive !== 0"
                    class="btn btn-outline-primary btn-rounded mr-3 mb-3 btn-action float-right">
                    <i class="fa fa-arrow-left"></i>
                    Anterior
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
